/*
  Magic Dust · Probador 3D — lanzador de los botones (ficha y listados).
  Abre el probador (magic-tryon.min.js, en Contenido > Archivos) con la configuración que pinta
  el tema en <script type="application/json" data-md-tryon-config>:
    · Ficha: bloque «MD · Probador 3D» ([data-md-tryon] con su botón [data-md-tryon-open]).
    · Listados: snippet md-tryon-global ([data-md-tryon-global]); se añade un botón sobre la foto
      de cada tarjeta de producto que tenga modelo 3D.
  En «Solo vista previa» los botones solo aparecen en el editor de temas o con ?probador=1.
*/
(function () {
  'use strict';
  if (window.MDTryOnLauncher) {
    if (window.MDTryOnLauncher.refresh) window.MDTryOnLauncher.refresh();
    else if (window.MDTryOnLauncher.reveal) window.MDTryOnLauncher.reveal();
    return;
  }

  var PREVIEW_KEY = 'mdTryonPreview';
  var CARD_SELECTOR = '.product-card-wrapper, .card-wrapper';
  var MEDIA_SELECTOR = '.card--block-media, .card__media, .card-media, .card__inner';
  var SKIP_SELECTOR = 'header, .header, .mega-menu, .menu-drawer, menu-drawer, [id*="__header"], .mdt-root, .predictive-search, predictive-search, .search-drawer, search-drawer, cart-drawer, .cart-drawer, quick-add-modal';
  var ICON = '<svg class="md-tryon-card__icon" aria-hidden="true" focusable="false" viewBox="0 0 44 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h40M6 6c0 7 3 12 8.5 12S22 13 22 9m0 0c0 4 2 9 7.5 9S38 13 38 6"/></svg>';

  var engine = null;
  var lastAdd = null;
  var cards = null;
  var observer = null;

  function previewOn() {
    var inUrl = /[?&]probador(=|&|$)/.test(window.location.search);
    var on = inUrl;
    try {
      if (inUrl) window.sessionStorage.setItem(PREVIEW_KEY, '1');
      else on = window.sessionStorage.getItem(PREVIEW_KEY) === '1';
    } catch (e) {}
    return on || !!(window.Shopify && window.Shopify.designMode);
  }

  function parseConfig(el) {
    if (!el) return null;
    var node = el.matches && el.matches('[data-md-tryon-config]') ? el : el.querySelector('[data-md-tryon-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function loadEngine(src) {
    if (window.MagicTryOn) return Promise.resolve(window.MagicTryOn);
    if (engine) return engine;
    engine = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { window.MagicTryOn ? resolve(window.MagicTryOn) : reject(new Error('MagicTryOn')); };
      s.onerror = function () { engine = null; s.remove(); reject(new Error('load')); };
      document.head.appendChild(s);
    });
    return engine;
  }

  // Añade a la cesta y actualiza el contador y el carrito lateral del tema (sin abrirlo).
  function addToCart(variant) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender(); } catch (e) {}
    var body = { items: [{ id: Number(variant.id), quantity: 1, properties: { _tryon: 'yes' } }] };
    if (sections.length) {
      body.sections = sections.map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'HTTP ' + res.status);
        lastAdd = data;
        try {
          if (drawer && data.sections) {
            sections.forEach(function (s) {
              var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
              if (el && data.sections[s.id] != null) el.innerHTML = drawer.getSectionInnerHTML(data.sections[s.id], s.selector);
            });
            drawer.classList.remove('is-empty');
            var inner = drawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
          }
          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'md-tryon', productVariantId: variant.id, cartData: data });
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  }

  // Al cerrar el probador después de añadir algo, se abre el carrito lateral.
  window.addEventListener('magictryon:close', function () {
    if (!lastAdd) return;
    lastAdd = null;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    setTimeout(function () {
      try {
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        drawer.open();
      } catch (e) {}
    }, 80);
  });

  function findItem(cfg, handle) {
    for (var i = 0; i < cfg.items.length; i++) if (String(cfg.items[i].id) === String(handle)) return cfg.items[i];
    return null;
  }

  function openTryOn(cfg, handle, variantId, btn, errEl) {
    if (!cfg || !cfg.items || !cfg.items.length || btn.getAttribute('aria-busy') === 'true') return;
    if (errEl) errEl.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    loadEngine(cfg.script).then(function (MT) {
      var items = JSON.parse(JSON.stringify(cfg.items));
      var item = findItem(cfg, handle);
      var vid = String(variantId || '');
      var hasVariant = !!item && item.variants.some(function (v) { return String(v.id) === vid; });
      MT.open({
        items: items,
        initialItem: item ? item.id : items[0].id,
        initialVariant: hasVariant ? vid : null,
        assets: cfg.assets,
        brand: { name: cfg.brand || 'MAGIC DUST' },
        eyebrow: cfg.eyebrow || '',
        locale: (document.documentElement.lang || 'en').slice(0, 2),
        cartUrl: (window.routes && window.routes.cart_url) || rootUrl() + 'cart',
        onAddToCart: addToCart
      });
    }).catch(function () {
      if (errEl) errEl.hidden = false;
      else if (btn.getAttribute('data-href')) window.location.href = btn.getAttribute('data-href');
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  }

  // ---------------------------------------------------------------- ficha
  function reveal() {
    if (!previewOn()) return;
    var els = document.querySelectorAll('[data-md-tryon][data-preview-only]');
    for (var i = 0; i < els.length; i++) els[i].hidden = false;
  }

  function openFromProduct(btn) {
    var root = btn.closest('[data-md-tryon]');
    var cfg = parseConfig(root);
    if (!cfg) return;
    var scope = root.closest('product-info, .shopify-section, section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    openTryOn(cfg, cfg.product, (input && input.value) || cfg.variant, btn, root.querySelector('.md-tryon__error'));
  }

  // ------------------------------------------------------------- listados
  function handleFromHref(href) {
    try {
      var m = new URL(href, window.location.href).pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]).toLowerCase() : null;
    } catch (e) { return null; }
  }

  function variantFromHref(href) {
    try { return new URL(href, window.location.href).searchParams.get('variant'); } catch (e) { return null; }
  }

  function setupCards() {
    var host = document.querySelector('[data-md-tryon-global]');
    if (!host) return null;
    var vis = host.getAttribute('data-visibility') || 'preview';
    if (vis === 'off' || (vis !== 'all' && !previewOn())) return null;
    var cfg = parseConfig(host);
    if (!cfg || !cfg.items || !cfg.items.length) return null;
    var by = {};
    cfg.items.forEach(function (it) { by[String(it.id).toLowerCase()] = it; });
    return {
      cfg: cfg,
      by: by,
      label: host.getAttribute('data-label') || 'Try on',
      pos: host.getAttribute('data-position') || 'br'
    };
  }

  function decorate() {
    if (!cards) return;
    var list = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var card = list[i];
      var band = card.closest('.md-char-item'); if ((band || card).querySelector('[data-md-tryon-card]') || card.closest(SKIP_SELECTOR)) continue; band = band && band.querySelector('.md-char__price');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var href = link.getAttribute('href');
      var handle = handleFromHref(href);
      var item = handle && cards.by[handle];
      if (!item) continue;
      var media = card.querySelector(MEDIA_SELECTOR) || card;
      if (window.getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'md-tryon-card md-tryon-card--' + (band ? 'band' : cards.pos);
      b.setAttribute('data-md-tryon-card', '');
      b.setAttribute('data-handle', item.id);
      b.setAttribute('data-href', link.href);
      var v = variantFromHref(href);
      if (v) b.setAttribute('data-variant', v);
      b.setAttribute('aria-label', cards.label + ' · ' + item.title);
      b.innerHTML = ICON + '<span class="md-tryon-card__label"></span>';
      b.querySelector('.md-tryon-card__label').textContent = cards.label;
      if (band) band.appendChild(b); else media.appendChild(b);
    }
  }

  function startCards() {
    cards = setupCards();
    if (!cards) return;
    decorate();
    if (observer || !window.MutationObserver) return;
    var timer = null;
    observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(decorate, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // --------------------------------------------------------------- eventos
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var cardBtn = t.closest('[data-md-tryon-card]');
    if (cardBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (cards) openTryOn(cards.cfg, cardBtn.getAttribute('data-handle'), cardBtn.getAttribute('data-variant'), cardBtn, null);
      return;
    }
    var btn = t.closest('[data-md-tryon-open]');
    if (btn) {
      e.preventDefault();
      openFromProduct(btn);
    }
  }, true);

  // Precarga el motor (≈1 MB) cuando el cliente se acerca a un botón, no antes.
  function warm(e) {
    if (window.MagicTryOn || engine) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('[data-md-tryon-open], [data-md-tryon-card]');
    if (!el) return;
    var cfg = el.hasAttribute('data-md-tryon-card') ? cards && cards.cfg : parseConfig(el.closest('[data-md-tryon]'));
    if (cfg && cfg.script) loadEngine(cfg.script).catch(function () {});
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  function refresh() {
    reveal();
    if (!cards) startCards();
    else decorate();
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:block:select', reveal);

  window.MDTryOnLauncher = { reveal: reveal, refresh: refresh, open: openFromProduct };

  function init() {
    reveal();
    startCards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
